import { IPodcastDTO } from '@/modules/podcasts/dtos/podcast.dto';
import { IPodcast } from '@/modules/podcasts/entities/podcast.entity';

export class PodcastMapper {
  public static toPresentation(podcast: IPodcastDTO): IPodcast {
    return {
      id: podcast.id,
      name: podcast.nome,
      thumbnail: podcast.thumbnail,
      description: podcast.descricao,
      createdAt: podcast.criadoEm,
      episodeCount: podcast.numeroDeEpisodios,
      presignedUrl: podcast.presignedUrl,
    };
  }

  public static toDTO(podcast: IPodcast): IPodcastDTO {
    return {
      id: podcast.id,
      nome: podcast.name,
      thumbnail: podcast.thumbnail,
      descricao: podcast.description,
      criadoEm: podcast.createdAt,
      numeroDeEpisodios: podcast.episodeCount,
      presignedUrl: podcast.presignedUrl,
    };
  }
}
